<mat-drawer-container autosize>
    <mat-drawer #drawer class="pt-5 matdrawer" mode="side" opened>
        <!-- <div class=" mt-3 pt-5">
            <strong class="mat-drawer-title font18">Recents</strong> -->
        
        <div class="pt-3 pl-4">
            <strong class="mattitle">Organizations</strong>
        </div>
        <div class="childGroupList pt-2">
            <ul>
                <li *ngFor="let grp of organizations" class="cursor" (click)="selectOrganization(grp)" (keypress)="selectOrganization(grp)"
                [ngClass]="grp.isSelected == true ? 'grpList span2':'grpList Span'" >
                <span class="OrgLabel mat-subheading-2" id="{{grp.organizationId}}">{{grp.organizationName}}</span>                
            </li>
            </ul>
        </div>
        <mat-list class="pl-4">
        </mat-list>
    </mat-drawer>
    <mat-drawer-content class="">
        <div class="sidenav-content pt-5">
            <div class="mat-drawer-content-container">
                <img src="/assets/icons/Admin1.svg" height="25px" aria-label="managementLogo" alt="admin icon" />
                <p class="mat-drawer-content-title mat-title pl-3">Admin</p>
            </div>
            <div [HideIfUnAuthorized]="'Super Admin'" class="row ml-5 firstrow" [ngClass]="{'mt-5' : loggedInUserTypeId != '1'}">
                <button mat-stroked-button class="button-drawer" (click)="Create_EditOrganization(null)"> 
                    Create new organization</button>
            </div>
            <div class="row col-11 px-0 mt-5 mx-5" [ngClass]="{'pt-5' : loggedInUserTypeId != '1'}">
                <div class="entityDet-title">
                    <div class="col-2" style="margin-top: -20px;">
                        <div class="avatar-small">
                            <ng-template [ngIf]="isImagePath == true">
                                <img class="avatar-img rounded-circle" [src]="imagePath" alt="logo" />
                              </ng-template>
                              <ng-template [ngIf]="isImagePath == false">
                                <img src="/assets/icons/images_nologo.jpg" class="avatar-img rounded-circle" alt="logo">
                              </ng-template>
                            <!-- <img src="/assets/icons/images_nologo.jpg" class="avatar-img rounded-circle"> -->
                            <span class="sub-title pl-3 mat-subheading-2">Logo</span>
                        </div>
                    </div>

                    <div class="col-10">
                        <div class="row">
                            <div class="col-8">
                                <div class="sub-title" >
                                    <span class="mat-subheading-2"> Organization name:</span>
                                    <span class="blueCol mat-subheading-2">
                                        {{selectedOrgName}}
                                    </span>
                                </div>
                            </div>
                            <div class="col-2">
                                <!-- <div class="sub-title mat-subheading-2">
                                    <span class="mat-subheading-2"> Organization Process Group:</span>
                                    <span class="blueCol">

                                    </span>
                                </div> -->
                            </div>
                            <div class="col-2 pt-2 d-flex justify-content-end">
                                <mat-icon class="icon-text" title="Edit"
                                    (click)="Create_EditOrganization(selectedOrgEdit)">
                                    <img class="iconzoom" src="/assets/icons/edit1.svg" alt="edit icon" />
                                </mat-icon>
                                <mat-icon class="icon-text" title="Delete" (click)="deleteSelectedOrg()">
                                    <img class="iconzoom" src="/assets/icons/Delete1.svg" alt="Delete icon" />
                                </mat-icon>
                            </div>
                        </div>
                        <div class="row pt-3 col">
                            <div class="sub-title ">
                                <span class="mat-subheading-2">Organization description: </span>
                                <span class="blueCol wordbreak">
                                    {{selectedOrgDesc}}
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4 ml-5">
                <button mat-stroked-button  class="button-drawer" (click)="Create_Editgroup(null)"> 
                    Add new group</button>
                <div class="col">

                    <button *ngIf="data.length>0" mat-stroked-button  class="button-drawer" (click)="Manage_groupUsers()"> 
                        Manage group users</button>

                </div>
            </div>
            <div *ngIf="data != null && data.length > 0" class="row col-11 px-0 mt-3 mx-5  borderRadBtm">
                <table mat-table aria-details="Group table"
                    [dataSource]="dataSource | paginate: {itemsPerPage: size, currentPage: pageIndex, totalItems: data.length}"
                   multiTemplateDataRows>
                    <ng-container matColumnDef="groupName">
                        <th id="GroupName" mat-header-cell *matHeaderCellDef class="table-heading " style="width: 30%;">
                            <p class="mat-body-2"> Group
                                name</p>
                        </th>
                        <td headers="OrgGroup Pagination GroupName" mat-cell *matCellDef="let element" style="width: 30%;"> {{element.groupName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="groupDescription">
                        <th id="GroupDescription" mat-header-cell *matHeaderCellDef class="table-heading grpname">
                            <p class="mat-body-2">Group description</p>
                        </th>
                        <td headers="OrgGroup Pagination GroupDescription" mat-cell *matCellDef="let element" class="grpname wordbreak">
                            {{element.groupDescription}} </td>
                    </ng-container>
                    <ng-container matColumnDef="Actions">
                        <th id="Actions" mat-header-cell *matHeaderCellDef class="table-heading action">
                            <p class="mat-body-2">Actions</p>
                        </th>
                        <td headers="OrgGroup Pagination Actions" mat-cell *matCellDef="let element" class="action">
                            <mat-icon class="mr-2 icon-grid" title="Edit" (click)="Create_Editgroup(element)">
                                <img class="iconzoom" src="/assets/icons/edit1.svg" alt="edit icon" />
                            </mat-icon>
                            <mat-icon class="mr-2 icon-grid" title="Delete" (click)="deleteGroup(element)">
                                <img class="iconzoom" src="/assets/icons/Delete1.svg" alt="Delete icon" />
                            </mat-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="header-row-first-group">
                        <th id="OrgGroup" mat-header-cell *matHeaderCellDef [attr.colspan]=displayedColumns.length class="borderRad">
                            <div class="mat-subheading-1 text-left heading-color">
                                <p  class="mat-subheading-1 font" style="font-size: 16px !important;">{{selectedOrgName}} -
                                    Groups</p>
                            </div>
                        </th>
                    </ng-container>
                    <ng-container matColumnDef="header-row-size-group">
                        <th id="Pagination" mat-header-cell class="pageItems" *matHeaderCellDef [attr.colspan]=displayedColumns.length>
                            <div class="mat-caption">
                                Items per page:
                                <mat-select [(value)]="size" (valueChange)="paginate(pageIndex)"
                                    style="width: 50px;margin-left: 15px">
                                    <mat-option [value]="5">5</mat-option>
                                    <mat-option [value]="10">10</mat-option>
                                    <mat-option [value]="20">20</mat-option>
                                </mat-select>
                            </div>
                        </th>
                    </ng-container>
                    <tr mat-header-row class="tableHeading" *matHeaderRowDef="['header-row-first-group']; sticky: true">
                    </tr>
                    <tr mat-header-row class="pageItems" *matHeaderRowDef="['header-row-size-group']; sticky: true"></tr>
                    <tr mat-header-row class="pageItems" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row  *matRowDef="let element; columns: displayedColumns;" class="example-element-row pageItems">
                    </tr>
                </table>              
                <div class="pagination1 w-100 borderRadBtm">
                    <pagination-controls (pageChange)="paginate($event)"></pagination-controls>
                </div>                        
            </div>
            <div *ngIf="!data.length && data.length == 0" class="row ml-5 mr-5 ">
                <mat-card class="row col-md-12 ml-md-0 my-3">
                  <span  class="font14 lightBlue">No records found</span>
                </mat-card>        
            </div>    
            <!-- <button mat-raised-button  class="arrow-btn-style" (click)="drawer.toggle();changeArrowIcon();">
                <fa-icon *ngIf="!arrowIconToggle" [icon]="faAngleLeft" style="font-size:15px;color:#0f6bc1"></fa-icon>
                <fa-icon *ngIf="arrowIconToggle" [icon]="faAngleRight" style="font-size:15px;color:#0f6bc1"></fa-icon>
            </button> -->
            <div class="arrow-btn-style" (click)="drawer.toggle();changeArrowIcon();"
                (keypress)="drawer.toggle();changeArrowIcon();">
                <!-- <mat-icon *ngIf="!arrowIconToggle" class="arrowIconStyle">keyboard_arrow_left</mat-icon>
                <mat-icon *ngIf="arrowIconToggle" class="arrowIconStyle">keyboard_arrow_right</mat-icon> -->
                <img class="sidetoggle" *ngIf="arrowIconToggle" [src]="'assets/icons/sidetoggle.svg'" alt="Side Toggle Icon">
                <img class="sidetoggle" *ngIf="!arrowIconToggle" [src]="'assets/icons/sidetoggle.svg'" alt="Side Toggle Icon">
            </div>
        </div>
        
        <!-- Modal-->
        <!-- Modal For Group delete -->

        <!-- Modal For Organization delete -->

    </mat-drawer-content>


</mat-drawer-container>
<app-modal class="deletePopup" [ngClass]="deletePopup" [modalSize]="deleteModalSize" [modalText]="deleteModalText"
    *ngIf="!hideDeletePopUp" (modalClose)="closeDelete()">
    <div class="modal-body-extended deletePopupMsg">
        <label>Are you sure you want to delete this Group?</label>
    </div>
    <div class="modal-footer-extended" style="text-align: center;">
        <br />
        <app-button [btnText]="deleteModalbtnText" [btnStyle]="modalbtnWithText" [btnType]="modalbtnRect"
            [btnColor]="modalbtnBlue" [btnSize]="modalbtnMedium" (click)="confirmDelete()"></app-button> &nbsp;
        <app-button [btnText]="deleteModalbtncancelText" [btnStyle]="modalbtnWithText" [btnType]="modalbtnRect"
            [btnColor]="modalbtnBlue" [btnSize]="modalbtnMedium" (click)="closeDelete()"></app-button> &nbsp;
    </div>
</app-modal>
<app-modal class="deletePopup" [ngClass]="deletePopup" [modalSize]="deleteModalSize" [modalText]="deleteModalText"
    *ngIf="!hideDeleteOrgPopUp" (modalClose)="closeOrgDelete()">
    <div class="modal-body-extended deletePopupMsg">
        <label>Are you sure you want to delete this Organization?</label>
    </div>
    <div class="modal-footer-extended" style="text-align: center;">
        <br />
        <app-button [btnText]="deleteModalbtnText" [btnStyle]="modalbtnWithText" [btnType]="modalbtnRect"
            [btnColor]="modalbtnBlue" [btnSize]="modalbtnMedium" (click)="confirmOrgDelete()"></app-button> &nbsp;
        <app-button [btnText]="deleteModalbtncancelText" [btnStyle]="modalbtnWithText" [btnType]="modalbtnRect"
            [btnColor]="modalbtnBlue" [btnSize]="modalbtnMedium" (click)="closeOrgDelete()"></app-button> &nbsp;
    </div>
</app-modal>